import { hashKey, QueryClient } from "@tanstack/react-query";
import { minuteMs } from "verdi-common/timeConstants";
import { SessionHandler } from "verdi-web-client";
import { ApiError } from "./orval/api-error";

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            // Scope cache per organization to allow for switching organizations
            queryKeyHashFn: (queryKey) => hashKey([SessionHandler.curUser ?? null, ...queryKey]),
            staleTime: 5 * minuteMs,
            gcTime: 60 * minuteMs,
            refetchOnWindowFocus: false,
            refetchOnReconnect: true,
            networkMode: "offlineFirst",
            // Don't retry 4xx errors since by definition they likely won't succeed on retry
            retry: (failureCount, error) =>
                error instanceof ApiError && error.status < 500 ? false : failureCount < 2,
        },
        mutations: {
            // Match the queries above: attempt the request instead of pausing. React Query's default
            // (`online`) parks a write started while offline and dispatches it whenever the connection
            // returns — long after the UI has reported a failure. Attempting it fails fast instead, so a
            // write the user was told about is the only write that ever reaches the server.
            networkMode: "offlineFirst",
        },
    },
});
